import fetchWrapper, {putWrapper, postWrapper} from '../../utils/fetchWrapper';
import stringHasValue from '../../utils/string-has-value';

const MESSAGING_SERVICE_TWILIO_ROUTE = "api/messaging/twilio";
const LEGACY_TWILIO_ROUTE = "api/twilio";

const twilioService = (routeBase = MESSAGING_SERVICE_TWILIO_ROUTE) => {
  const loadHasTwilio = async () => {
    return await fetchWrapper({ url: `${routeBase}/hasTwilio` });
  };

  const loadInbox = async(timestampDate) => {
    let path = routeBase;
    const timestamp = timestampDate ? timestampDate.toISOString() : null;
    if (stringHasValue(timestamp)) {
      path = `${path}?timestamp=${timestamp}`;
    }
    const data = await fetchWrapper({ url: path });
    const datesMapped = {...data,
      timeStamp: data?.timeStamp ? new Date(data.timeStamp) : null,
      inbox : Array.isArray(data?.inbox) ? data.inbox.map(conversation => {
        return {
          ...conversation,
          messages:conversation.messages.map(message => ({
            ...message,
            dateStamp: new Date(message.dateStamp),
          }))
        }
      }) : null
    }
    return datesMapped;

  }

  const sendReply = async (to, message) => {
    const path = `${routeBase}/sendSms`;
    const data = await postWrapper({ url: path, data: { to, message }});
    return {...data, dateStamp: new Date(data.dateStamp)};
  };

  const deleteThread = () => {
  }

  const setThreadRead = async (recipientNumber) => {
    const path = `${routeBase}/markRead`;
    return await putWrapper({ url: path, data: recipientNumber });
  }

  return {loadHasTwilio, loadInbox, sendReply, deleteThread, setThreadRead}
};

export {LEGACY_TWILIO_ROUTE, MESSAGING_SERVICE_TWILIO_ROUTE};

export default twilioService;
